module.exports = __webpack_public_path__ + "static/media/buy.31be58ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy.png
// module id = 976
// module chunks = 0